import { PointsAccountingException } from '@/domain/points/accounting/exception/PointsAccountingException'

export class CouldNotGetTransactionsException extends PointsAccountingException {

}
